import React from 'react';

const FileIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      xmlnsXlink='http://www.w3.org/1999/xlink'
    >
      <rect width='24' height='24' fill='url(#pattern0_25722_71363)' />
      <defs>
        <pattern
          id='pattern0_25722_71363'
          patternContentUnits='objectBoundingBox'
          width='1'
          height='1'
        >
          <use xlinkHref='#image0_25722_71363' transform='scale(0.01)' />
        </pattern>
        <image
          id='image0_25722_71363'
          width='100'
          height='100'
          preserveAspectRatio='none'
          xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAADAUlEQVR4nO3du2tUQRTH8eMDomTnBOOjEmwW95yFWNoGK0UsxMpSRLASxM5CBAXxVcSgEKxF/wCxEMF0+QuE7JwIYjoJ8VWKuHKjFq6rkeTuvWfm/j4w1UJ25n6Z2QRy7xIBAAAAAAAAAAAAAEAu5ml6+9JE54ixXLWgDyPrUwvyYqNj2Hu8oQM7ql9ZYl5xd9JY71qQVWPtlzVoiMjdC7Elp6pfZSJ6LTkXg3woM4T9I0gvyCVj+YIoQ44nCzI7ihC2bpDidUT5TQz6YJQxbN0g2o+sXyPLaWq6yN3zo45h/xEEO4WIrNXeG4N+8hNEm71TRv25YRsI0tidYtQes6CffQbR5u0UC3Kiqhi2gSCNi2Isd7wHsSYdXxb0SRpBtBk7JQadTyWINWGnRNaFtIJo3jslxSCWc5RUg1iuUVIOYjlGST2I5RYlhyCWU5Sqg/SJtgzOwYJcLOfnZ/ArcdVBeq2DewbnsMTdY+W9R+JRqg4SuXt4cA59oq3G8gxR6ggS9NqweRRRei09Wbweg97c7LAg122yzZSa6neIvFvc3Ql1r9utqoPYjyPldt3rdquOIJH1WwydM3Wv3aV6doiuRbGgN5Zp/866r4ErdQWxX2GCLEeWy4vjnSn8S6mDIPZHIP0Yg7wvZ+hzSo23IFbusbhAqUEQZxDEGQRxBkGcQRBnEMQZBHEGQZxBEGcQxBkEcQZBnEEQZxDEGQRxBkGcQRBnEMQZBHEGQZxBEGcQxBkEcQZBnEEQZxDEGQRp+MNnrMogQV9Saizo43yDyCNKTXF7WbZBWG5RamLQ43VfOBvRWOLOUUpN1Q/BtKpGsSZqj1GKjOVe7ReQyx2RZYZSVTzuoriVLKfd8Xr80D5K/RsRar+QXM4o1kI5sKD3098dMku56BNtS/nzJLLMFGug3FjQs8VtxQntitXsnwzxdmJqV/GHlbGu1H7B+a9jpZhjMVdqirVjrCXTxnLFgsxt9kvBbBPj53vPrc2lJdNZHk8AAAAAAAAAAAAAANRY3wG3CYa0bH+a6QAAAABJRU5ErkJggg=='
        />
      </defs>
    </svg>
  );
};

export default FileIcon;
